import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Box, Icon, Link, P, H2, Span, Pill } from '@maui/elements'

export const stripHtml = (html) => {
  if (typeof html !== 'string') {
    return ''
  }
  const doc = new DOMParser().parseFromString(html, 'text/html')
  return doc.body.textContent || ''
}

export function useMemoizedDescription(executiveSummary, isightComment) {
  const memoizedStripHtml = useMemo(() => {
    if (executiveSummary) return stripHtml(executiveSummary)
    if (isightComment) return stripHtml(isightComment)
  }, [executiveSummary, isightComment])
  return memoizedStripHtml
}

export const formattedDate = (dateString) => {
  if (!dateString) return ''
  const date = new Date(dateString)
  const options = { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' }
  return date.toLocaleDateString(undefined, options)
}

export const SearchResultHeader = ({ subHeaderText, date }) => {
  return (
    <Box pb='8px' display='flex'>
      <Box flex='1'>
        <P m={0} textStyle="sectionLabel1" color='colorTextDeemphasis'>{subHeaderText}</P>
      </Box>
      <Box>
        <P m={0} textStyle="sectionLabel1" color='colorTextDeemphasis'>{formattedDate(date)}</P>
      </Box>
    </Box>
  )
}

SearchResultHeader.propTypes = {
  date: PropTypes.string,
  type: PropTypes.string
}

export const SearchResultTitle = ({ name, titleIcon, url }) => {
  return (
    <Box>
      <Link
        href={url}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Box display='flex' color='colorActionPrimary'>
          {titleIcon && <Box pr='10px'>{titleIcon}</Box>}
          <H2
            m={0}
            textOverflow='ellipsis'
            overflow='hidden'
            whiteSpace='nowrap'
            textTransform='none'
          >
            {name}
          </H2>
        </Box>
      </Link>
    </Box>
  )
}

SearchResultTitle.propTypes = {
  name: PropTypes.string,
  titleIcon: PropTypes.node,
}

export const SearchResultDescription = ({ description = '' }) => {
  if (!description) return null
  return (
    <Box>
      <Box>
        <P
          style={{
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: '3',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'normal',
            display: '-webkit-box'
          }}
          textStyle='bodySmall'
          color='colorTextMain'
        >
          {description}
        </P>
      </Box>
    </Box>
  )
}

SearchResultDescription.propTypes = {
  description: PropTypes.string
}

export const SearchResultPill = ({ type, value }) => {
  return (
    <Pill>
      <Box display='flex' gap='4px'>
        <Box display='flex' gap='4px'>
          {type}
        </Box>
        <Box display='flex' gap='4px'>
          {value}
        </Box>
      </Box>
    </Pill>
  )
}

SearchResultPill.propTypes = {
  type: PropTypes.node,
  value: PropTypes.node
}

export const SearchResultPillMore = ({ values }) => {
  return values.length > 1 && (
    <>
      <Span color='colorTextDeemphasis'>
        <Icon name='add' size='sm' verticalAlign='-1px'/>
      </Span>
      <Span color='colorTextDeemphasis' textStyle='sectionLabel1'>{values?.length - 1} More</Span>
    </>
  )
}

SearchResultPillMore.propTypes = {
  values: PropTypes.array
}
